import React, { useState } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import Input from '@mui/material/Input';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const PasswordInput = ({HandlePasswordChange}) => {
  const [showPassword, setShowPassword] = useState(false);
  const handleTogglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const inputStyle = {
    border:"1px solid #E8E8E8",
    borderRadius:"5px",
    backgroundColor: 'white', // Set your desired background color here
    '&:hover': {
      borderColor: 'blue', // Set your desired border color on hover
    },
    '&.Mui-focused': {
      borderColor: 'green', // Set your desired border color when focused
    },  
    "& .MuiInputBase-input": {
        "&::placeholder": {
          color: "#000000",
          opacity: 1,
          fontSize: '16px',
          fontWeight: "400",
          lineHeight: "16px",
          fontFamily: "inter",
        },
      },
      
  };

  return (
    <Input
    sx={{p:"15px",mt:"15px"}}
      type={showPassword ? 'text' : 'password'}
      placeholder="Enter your password"
      endAdornment={
        <InputAdornment position="end">
          <IconButton onClick={handleTogglePassword} edge="end">
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>
      }
      onChange={HandlePasswordChange}
      disableUnderline
      disableAnimation
      style={inputStyle}
    />
  );
};

export default PasswordInput;
